import { cn } from "lib/utils";
import React from "react";

export default function SinglePageCenter({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn("flex flex-col justify-center items-center h-[calc(100vh-7rem)]", className)}>
      <div className="invisible" />
      <div className="w-full">{children}</div>
      <div className="invisible" />
    </div>
  );
}
